import { render } from "./DutiesContent.vue?vue&type=template&id=1ae0a412&ts=true"
import script from "./DutiesContent.vue?vue&type=script&lang=ts"
export * from "./DutiesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__